<aside
  class="sidebar"
  [attr.data-position]="position()"
  [ngClass]="[isOpen() ? 'opened' : 'closed']"
>
  <button (click)="onCloseClick()" class="sidebar__close-button">
    <i class="sidebar__close-button_icon icon icon-cross"></i>
  </button>

  <div class="sidebar__content">
    <ng-content />
  </div>
</aside>

@if (isOpen()) {
  <div class="sidebar-overlay" (click)="onCloseClick()"></div>
}
